export const TEST_ID = 'activityCards';
